<template>
	<div class='online-details row'>
		<LoadingScreen :header="getText('TransactionLoadingHeader')" :message='loading_message' v-if='loading_message.length > 0'/>

		Test
	</div>
</template>

<style scoped lang="scss">
	.online-details{
		position: relative;
		min-height: 400px;
	}
</style>

<script>
import store from "@/store/";
import { mapGetters } from "vuex";

import { GET_ORDER_DETAILS, VALIDATE_PACKAGE } from "@/store/actions.type";
import {
	SET_INVOICE_DATA,
	SET_BILLING_INFO,
	SET_PAYMENT_METHOD
} from "@/store/mutations.type";

// Language / Localization
import LanguageService from "@/common/language.service";

import LoadingScreen from "@/components/general/LoadingScreen";
import ErrorMessage from "@/components/messages/ErrorMessage";

export default {
	name: "Online",
	components: {
		LoadingScreen,

		ErrorMessage
	},
	props: {},
	data(){
		return {
			loading_message: this.getText('TransactionLoadingText')
		};
	},
	beforeMount(){
		var url_data = {
			package: this.$route.query.response,
			signature: this.$route.query.signature
		};

		// First, Validate the package
		store.dispatch(VALIDATE_PACKAGE, url_data).then(data => {
			if(!data.valid) {
				this.loading_error(this.getError('ServerError'));
				return;
			}

			// Now lets process the valid package
			let response = this.$route.query.response;
			let signature = this.$route.query.signature;

			try {
				response = JSON.parse(response);
			} catch (e) {
				this.loading_error(this.getError('ServerError'));
				return;
			}

			// Ensure there were no error responses
			if(response.Error !== undefined && response.Error.Code.length > 0) {
				this.error_message = this.getError(response.Error.Code);
				this.load_order(response.OrderId);
				return;
			}

			// Based on the result, handle it differently
			if(!response.Captured) {
				// Only happens if captured is false and no errors (ex, offline method redirect)
			}
			this.$router.push({ name: 'Order', params: { orderId: response.OrderId }});
		}).catch(error => {
			this.loading_error(this.getError('ServerError'));
			return;
		});
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		getError(key){
			return LanguageService.getError(key);
		},
		load_order: function(order_id){
			// Load order data, then set store and reload page
			store.dispatch(GET_ORDER_DETAILS, order_id).then(data => {

				// Make sure we have proper items
				if(data.Items === undefined) throw "Error";
				var invoice_item = data.Items.filter(x => x.Sku == "Invoice");
				if(invoice_item.length < 1) throw "Error";

				// Grab merchant amount
				var invoice_amount = invoice_item[0].MerchantPrice;

				// STEP 1: Set our invoice data
				store.commit(SET_INVOICE_DATA, {
					id: data.ReferenceId,
					amount: invoice_amount,
					payment_country: data.Consumer.Country
				});

				// Optional National Identifier
				if(data.Consumer.NationalIdentifier === undefined){
					data.Consumer.NationalIdentifier = "";
				}

				// Optional Birthdate
				if(data.Consumer.BirthDate === undefined){
					data.Consumer.BirthDate = "";
				}

				// STEP 2: Set our Billing data
				store.commit(SET_BILLING_INFO, {
					Name: data.Consumer.Name,
					Email: data.Consumer.Email,
					Address: data.Consumer.Address,
					City: data.Consumer.City,
					Region: data.Consumer.Region,
					Country: data.Consumer.Country,
					PostalCode: data.Consumer.PostalCode,
					Phone: data.Consumer.Phone,
					NationalIdentifier: data.Consumer.NationalIdentifier,
					BirthDate: data.Consumer.BirthDate
				});

				// STEP 3: Set our payment data
				store.commit(SET_PAYMENT_METHOD, {
					Class: data.Payment.Class,
					Id: data.Payment.Method,
					Name: ""
				});

				// Now route back to primary view
				this.$router.push({ name: 'Home', params: { error: this.error_message }});

			}).catch(error => {
				this.loading_error(this.getError('ServerError'));
				return;
			});
		},
		loading_error: function(message){
			// An error occured, route to home with message
			this.$router.push({ name: 'Home', params: { error: message }});
		},
		...mapGetters(["merchant"])
	}
}
</script>
